import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import edit from "../Images/edit.png";
import Delete from "../Images/delete.png";
import home from "../Images/home.png";
// import office from "../Images/office.png";
import CustomModal from "../../../MyActivityComponents/Modals/CustomModal";
import CustomInput from "../../../MyActivityComponents/Inputs/CustomInput";
import CustomizedMenus from "../../../MyActivityComponents/DropDown";
import { Stack } from "@mui/material";
import {
  useAddAddressMutation,
  useGetUserQuery,
  useDeleteAddressMutation,
  useUpdateAddressMutation,
} from "../../../../api/profile";
import CircleLoader from "../../../Loader/CircleLoader";
import { useFormik } from "formik";
// import * as yup from "yup";
// import { addressSchema } from "../../../../Schemas";

const buttonStyles = {
  height: "40px",
  padding: "7px 20px",
  backgroundColor: "#2B817B;",
  borderRadius: "6px",
  color: "white",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#2B817B"
  }
};

const MainAddressSection = () => {
  const [saveAddressModal, setSaveAddressModal] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [addAddress, { isLoading }] = useAddAddressMutation();
  const { data: userData, isLoading: fetchingUSer } = useGetUserQuery();
  const [deleteAddress] = useDeleteAddressMutation();

  useEffect(() => {
    if (userData && userData.data)
      setAddresses(
        userData.data.profile.addresses.filter((e) => {
          if (e.address) return e;
        })
      );
  }, [userData]);

  const handleDeleteAddress = (id) => {
    deleteAddress({ id });
  };

  const handleSubmitForm = (values) => {
    console.log("values", values);
    addAddress(values).then(() => {
      setSaveAddressModal(false);
    });
  };

  return fetchingUSer ? (
    <p>Loading...</p>
  ) : (
    <Container sx={{ width: "100%" }}>
      <Container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 3,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Outfit",
            fontWeight: "600",
            fontSize: { lg: "24px", md: "24px", sm: "18px", xs: "18px" },
            lineHeight: "150%",
            color: "#000000;",
          }}
        >
          Saved Address
        </Typography>
        <Button sx={buttonStyles} onClick={() => setSaveAddressModal(true)}>
          Add new address
        </Button>
      </Container>

      {addresses.map((item) => (
        <>
          <Container
            maxWidth="xl"
            sx={{
              padding: "16px",
              height: "94px",
              border: "1px solid #E1E1E6",
              borderRadius: "4px",
              marginTop: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: {
                    width: {
                      lg: "250px",
                      md: "250px",
                      sm: "200px",
                      xs: "200px",
                    },
                  },
                }}
              >
                <img style={{ marginRight: "5px" }} src={home} />

                <Typography
                  sx={{
                    fontFamily: "Outfit",
                    fontWeight: "600",
                    lineHeight: "180%",
                    fontSize: {
                      lg: "20px",
                      md: "20px",
                      sm: "16px",
                      xs: "16px",
                    },
                  }}
                >
                  {item.title}
                </Typography>
                {item.type === "default" && (
                  <Typography
                    sx={{
                      fontFamily: "Outfit",
                      fontWeight: "400",
                      lineHeight: "180%",
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "12px",
                        xs: "12px",
                      },
                      color: "#2B817B",
                      marginLeft: 1,
                    }}
                  >
                    Default Location
                  </Typography>
                )}
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontFamily: "Outfit",
                    fontWeight: "400",
                    fontSize: "16px",
                    color: "#545359",
                  }}
                >
                  {item.address}
                </Typography>
              </Box>
            </Box>

            <Box>
              <Button onClick={() => handleDeleteAddress(item._id)}>
                <img src={Delete} />
              </Button>
              <Button onClick={() => setSaveAddressModal(item)}>
                <img src={edit} />
              </Button>
            </Box>
          </Container>
        </>
      ))}

      {saveAddressModal && (
        <AddressModal
          handleClose={() => setSaveAddressModal(false)}
          handleOnSubmit={(e) => handleSubmitForm(e)}
          isEdit={typeof saveAddressModal === "object"}
          addressData={
            typeof saveAddressModal === "object" ? saveAddressModal : undefined
          }
        />
      )}
    </Container>
  );
};

const initailData = {
  title: "",
  address: "",
  type: "not-default",
};
const AddressModal = ({
  addressData = initailData,
  isEdit,
  handleOnSubmit,
  handleClose,
}) => {
  console.log("addressData", addressData);
  const [updateAddress, { isLoading }] = useUpdateAddressMutation();
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: addressData,
    // validationSchema: addressSchema,
    onSubmit: (values, action) => {
      isEdit
        ? updateAddress({ ...values, _id: addressData._id })
        : handleOnSubmit(values);
      action.resetForm();
      handleClose();
    },
  });

  return (
    <CustomModal isOpened={true} handleClose={handleClose} width={"40%"}>
      <form onSubmit={handleSubmit} autoComplete="off">
        <Stack spacing={2}>
          <CustomizedMenus
            value={values.type}
            onClick={(e) => setFieldValue("type", e)}
            items={[
              { id: "default", label: "Default" },
              { id: "not-default", label: "Not Default" },
            ]}
          />
          <CustomInput
            id="title"
            name="title"
            label={"Title"}
            value={values.title}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Title"
            errors={errors.title}
            touched={touched.title}
          />
          <CustomInput
            id="address"
            name="address"
            label={"Address"}
            value={values.address}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Address"
            errors={errors.address}
            touched={touched.address}
          />
          <Button
            sx={buttonStyles}
            type="submit">
            {isLoading ? <CircleLoader /> : "Save address"}
          </Button>
        </Stack>
      </form>
    </CustomModal>
  );
};
export default MainAddressSection;
